import { Dispatch } from 'redux';
import { axiosInstance, request } from './base';

export interface ConsultarDiaUtilResponse{
    dataValidada?: Date;
    diaUtil: boolean;
    proximoDiaUtil: Date | null;
}

export const GETValidarDiaUtil = async (dispatch: Dispatch, today: Date, stackRequest: boolean = false) => {
  if (typeof today !== 'object') {
    try {
      today = new Date(today);
    } catch (error) {
      return {
        diaUtil: true,
        proximoDiaUtil: null
      };
    }
  }
  if (!today) {
    return {
      diaUtil: true,
      proximoDiaUtil: null
    }
  }
  try {
    return await request(
      () => axiosInstance.get<ConsultarDiaUtilResponse>(`api/v1/feriados-nacionais/dia-util?data=${today.toISOString().split('T')[0]}`),
      dispatch,
      undefined,
      stackRequest
    );
  } catch (error) {
    return {
      diaUtil: true,
      proximoDiaUtil: null
    };
  }
};

export const POSTValidarDiasUteis = async (dispatch: Dispatch, datas: Date[], stackRequest: boolean = false) => {
  try {
    return await request(
      () => axiosInstance.post<ConsultarDiaUtilResponse[]>(
        `api/v1/feriados-nacionais/validar-dias-uteis`,
        { datas: datas }
      ),
      dispatch,
      undefined,
      stackRequest
    );
  } catch (error) {
    return [{
      dataValidada: new Date(),
      diaUtil: true,
      proximoDiaUtil: null
    }] as ConsultarDiaUtilResponse[];
  }
};
